import { State } from '../reducers/types'
import { OnboardingCounts, OnboardingTemplate } from 'src/interfaces/onboarding'

export const getOnboardingCounts = (state: State): OnboardingCounts | null =>
  state.onboarding.onboardingCounts

export const getOnboardingTemplates = (state: State): Array<OnboardingTemplate> =>
  state.onboarding.onboardingTemplates.sort((a, b) => a?.name?.localeCompare(b?.name))
